import { FC } from "react"

import BBSwitch from "../../form/Switch"
import { IEmailPreference, TEmailPreferenceKey } from "../../../../types"

interface Props {
  preference: IEmailPreference
  isEnabled: boolean
  onEnablePreference: (key: TEmailPreferenceKey) => void
}

const EmailPreference: FC<Props> = ({
  preference: { key, label, description },
  isEnabled,
  onEnablePreference
}) => {
  return (
    <div className="flex items-center justify-between py-3">
      <BBSwitch
        enabled={isEnabled}
        setEnabled={() => onEnablePreference(key)}
        label={label}
        description={description}
        switchPosition="left"
      />
    </div>
  )
}

export default EmailPreference
